<template>
    <div v-wechat-title="title" class="form-table-h380">
        <crud-facecade
            ref="drugapply-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="80%"
            :addButton="{ enabled: false}"
            :updateButton="{ enabled: false}"
            @approveApply="approveApply"
            @approveApply2="approveApply2"
            @loaddetail="loaddetail"
            @loadupdate="loadupdate"

        >
            <slot slot="filter">
                 <el-col :span="8">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
            </slot>
            <template slot="filter-after">
                <el-button type="primary" v-if="this.permissions && this.permissions.findIndex(item => item.permission === `drugapply:add`) != -1" size="mini" @click="loadadd()">创建<i class="el-icon--right"></i></el-button>
            </template>
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DrugApply`,
    components: { },
    props: {},
    data() {
        return {
            title: `药品申请`,
            o_dic_ward_id: undefined,
            // default_anes_section: null,
            rdate: [this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)],
            defaultuser: null,
            defaultsection: null,
            permissions: [],
            isdetail: false,
            issetoperatingward: false,
            url: {
                baseURL: `/api/Nursing/DrugApply`,
                get: () => {
                    let that = this
                    return new Promise((resolve, reject) => {
                        that.loadDrugApply(resolve, reject)
                    })
                },
                getOne: row => {
                    return this.loadOne(row)
                },
                post: row => {
                    return this.saveOne(row, `post`)
                },
                put: row => {
                    return this.saveOne(row, `put`)
                }
            }
        }
    },
    created() {
        // this.$store.dispatch("ADD_WARD_AUTH")
    },
    mounted() {
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.loadPermissions()
    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `active_ward`, `section_auth`, `sysuser/workers`]),
        workers() {
            return this[`sysuser/workers`]
        },
        dic_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward) {
                    this.o_dic_ward_id = this.active_ward.value
                }
                return this.o_dic_ward_id
            },
            set: function(v) {
                this.o_dic_ward_id = v
                this.issetoperatingward = true
            }
        },
        saveAsColumns() {
            return _.filter(this.columnList, { isCreatable: true })
        },
        sectionFidlerHospitalWard() {
            let section = _.cloneDeep(this[`section_auth`])
            console.log(`section`, section)
            return section
        },
        columnList() {
            let that = this
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `编号`,
                    // width: "180",
                    isListable: false,
                    isExpand: false,
                    isEditable: false,
                    isCreatable: false,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `apply_worker_name`,
                    label: `申请人`,
                    isListable: true,
                    isExpand: false,
                    width: `150`,
                    searchable: true,
                    colspan: 6
                },
                {
                    type: `select`,
                    prop: `approve_status`,
                    label: `申请状态`,
                    isListable: true,
                    isExpand: false,
                    width: `150`,
                    searchable: true,
                    colspan: 6,
                    options: [{ label: `未申请`, value: 0 }, { label: `申请中`, value: 1 }, { label: `申请通过`, value: 2 }]
                },
                {
                    type: `datetime`,
                    prop: `apply_date`,
                    label: `申请日期`,
                    isListable: true,
                    sortable: `desc`
                },
                {
                    type: `string`,
                    prop: `dic_section_name`,
                    label: `申请科室`,
                    colspan: 6,
                    width: `200`,
                    isListable: true,
                    isExpand: false,
                    sortable: true
                },
                {
                    type: `string`,
                    prop: `drug_section_name`,
                    label: `药房`,
                    colspan: 6,
                    width: `200`,
                    isListable: true,
                    isExpand: false,
                    sortable: true
                },
                {
                    type: `remoteselect`,
                    prop: `apply_worker_id`,
                    label: `申请人`,
                    default: this.defaultuser,
                    isEditable: true,
                    isCreatable: true,
                    readonly: this.isdetail,
                    colspan: 6,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    options: (that, { row }) => {
                        return q => {
                            let r = this.loadWorker(q, row)
                            console.log(`r`, r)
                            return r
                        }
                    },
                    change: (d, { row }) => {
                        if (row.apply_worker_id) {
                            let worker = that.workers.find(s => s.id == row.apply_worker_id.value)
                            if (worker) {
                                let section = this.sectionFidlerHospitalWard.find(s => s.label == worker.section_name)
                                this.$set(row, `dic_section_id`, section)
                            }
                        } else {
                            this.$set(row, `dic_section_id`, null)
                        }
                    }
                }, {
                    type: `remoteselect`,
                    prop: `dic_section_id`,
                    label: `申请科室`,
                    default: this.defaultsection,
                    colspan: 6,
                    width: `180`,
                    isEditable: true,
                    isCreatable: true,
                    readonly: this.isdetail,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    searchable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = this.sectionFidlerHospitalWard
                            if (q && q.keyword) {
                                return sections.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return sections
                            }
                        }
                    }
                },

                {
                    type: `remoteselect`,
                    prop: `drug_section_id`,
                    label: `药房`,
                    colspan: 6,
                    readonly: this.isdetail,
                    validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                    isEditable: true,
                    isCreatable: true,
                    searchable: true,
                    options: (that, { row }) => {
                        return q => {
                            let sections = this.sectionFidlerHospitalWard
                            if (q && q.keyword) {
                                return sections.filter(d => {
                                    return d.label.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                                })
                            } else {
                                return sections
                            }
                        }
                    }
                },
                {
                    type: `string`,
                    prop: `creator`,
                    label: `创建人`,
                    isListable: true
                },

                {
                    type: `datetime`,
                    prop: `create_date`,
                    label: `创建时间`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `200`,
                    isListable: true,
                    readonly: false,
                    options: function(that, { row }) {
                        if (row.approve_status == 0) {
                            return [
                                {
                                    class: `is-plain`,
                                    label: `提交申请`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `approveApply`,
                                    permission: `drugapply:approve`
                                },
                                {
                                    class: `is-plain`,
                                    label: `编辑`,
                                    icon: ``,
                                    type: `primary`,
                                    emit: `loadupdate`,
                                    permission: `drugapply:edit`
                                },
                                {
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `DeleteData`,
                                    permission: `drugapply:delete`
                                }
                            ]
                        } else {
                            if (row.approve_status == 1) {
                                return [
                                    {
                                        label: `申请通过`,
                                        icon: ``,
                                        type: `primary`,
                                        emit: `approveApply2`,
                                        permission: `drugapply:approve2`
                                    }
                                ]
                            } else {
                                return [
                                    {
                                        class: `is-plain`,
                                        label: `详情`,
                                        icon: ``,
                                        type: `primary`,
                                        emit: `loaddetail`,
                                        permission: `drugapply:detail`
                                    }
                                ]
                            }
                        }
                    }
                },
                {
                    type: `table`,
                    prop: `items`,
                    label: `药品`,
                    isEditable: true,
                    isCreatable: true,
                    options: [
                        {
                            type: `string`,
                            prop: `id`,
                            label: `排序`,
                            isKey: true
                        },
                        {
                            type: `remoteselect`,
                            prop: `dic_drug`,
                            label: `名称`,
                            width: `400`,
                            isListable: true,
                            readonly: this.isdetail,
                            options: `/api/AcisSystem/Drug/Search`,
                            change: (d, { row }) => {
                                console.log(row)
                                if (row.dic_drug) {
                                    let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                                    req.then(data => {
                                        console.log(`drug`, data)
                                        if (data.reference_number != null) {
                                            if (data.inventory != null) {
                                                this.$set(row, `apply_count`, data.reference_number - data.inventory)
                                            } else {
                                                this.$set(row, `apply_count`, data.reference_number)
                                            }
                                        } else {
                                            this.$set(row, `apply_count`, 0)
                                        }
                                    })
                                }
                            }
                        },
                        {
                            type: `number`,
                            prop: `apply_count`,
                            label: `申请数量`,
                            isListable: true,
                            readonly: this.isdetail,
                            default: 1
                        }, {
                            type: `number`,
                            prop: `reality_count`,
                            label: `实际发放数量`,
                            isListable: this.isdetail,
                            readonly: this.isdetail,
                            default: 0
                        }
                    ],
                    colspan: 24,
                    default: []
                }
            ]
        }
    },
    methods: {
        refreshList() {
            this.$refs[`drugapply-list`].ReloadListData()
        },
        loadPermissions() {
            let req = this.myaxios.get(`/api/AcisSystem/Authorization/GetPermissions`) // 获取当前用户的权限
            req.then(data => {
                this.permissions = data
            }).catch(e => {})
        },
        loadWorker(q, row) {
            // todo:是否需要判断手术区的员工
            let r = {
                // operatingWardId: (this.active_ward && this.active_ward.value.split(`_`)[1]),
                operatingWardId: 0,
                keyword: q && q.keyword
            }
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/Worker/SearchForChargeNew`, r)
                req.then(data => {
                    console.log(`SearchForChargeNew`)

                    console.log(data)
                    resolve(data)
                })
            })
        },
        loadDrugApply(resolve, reject) {
            let that = this
            let begintime = that.rdate[0]
            let endtime = that.$moment(this.rdate[1])
                .add(1, `days`)
                .format(`YYYY/MM/DD`)
            let req = that.myaxios.get(`/api/Nursing/DrugApply/GetByDate?begintime=${begintime}&endtime=${endtime}`)
            req.then(data => {
                console.log(data)
                console.log(`this.currentUser`, this.currentUser)
                // return d.label.indexOf(q.keyword) > -1 || d.card_no.indexOf(q.keyword) > -1 || d.jianpin.indexOf(q.keyword.toUpperCase()) > -1
                if (this.currentUser) {
                    this.defaultuser = { label: this.currentUser.dic_worker_name, value: this.currentUser.dic_worker_id, card_no: this.currentUser.card_no }
                    this.defaultsection = { label: this.currentUser.dic_worker_section_name, value: this.currentUser.dic_worker_section_id, jianpin: this.currentUser.dic_worker_section_code }
                }
                console.log(this.sectionFidlerHospitalWard)
                let r = _.map(data, d => {
                    let worker = that.workers.find(s => s.id == d.apply_worker_id)
                    let dicsection = this.sectionFidlerHospitalWard.find(s => s.value == d.dic_section_id)
                    let drugsection = this.sectionFidlerHospitalWard.find(s => s.value == d.drug_section_id)
                    // d.apply_worker_id = worker
                    d.apply_worker_name = worker && worker.name
                    d.dic_section_name = dicsection && dicsection.label
                    d.drug_section_name = drugsection && drugsection.label
                    return d
                })
                console.log(r)
                resolve(data)
            }).catch(e => reject(e))
        },
        approveApply({ row }) {
            let that = this
            if (row.approve_status === 0) {
                this.$confirm(`是否确定提交申请?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let req = this.myaxios.post(`/api/Nursing/DrugApply/ApproveApply?id=${row.id}&approve_status=1`)
                    req.then(data => {
                        that.$message.success(`操作成功！`)
                        this.refreshList()
                    })
                })
            } else {
                that.$message.error(`数据状态发生变化，请刷新重试！`)
            }
        },
        approveApply2({ row }) {
            let that = this
            if (row.approve_status === 1) {
                this.$confirm(`是否确定申请通过?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let req = this.myaxios.post(`/api/Nursing/DrugApply/ApproveApply?id=${row.id}&approve_status=2`)
                    req.then(data => {
                        that.$message.success(`操作成功！`)
                        this.refreshList()
                    })
                })
            } else {
                that.$message.error(`数据状态发生变化，请刷新重试！`)
            }
        },
        loaddetail({ row }) {
            this.$refs[`drugapply-list`].LoadingDetailView({ row: row, index: 1 })
            this.isdetail = true
        },
        loadupdate({ row }) {
            this.$refs[`drugapply-list`].LoadingUpdateView({ row: row, index: 1 })
            this.isdetail = false
        },
        loadadd() {
            this.$refs[`drugapply-list`].LoadingAddView()
            this.isdetail = false
        },
        loadOne(row) {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/DrugApply/GetById?id=${row.id}`)
                req.then(data => {
                    if (data) {
                        let worker = that.workers.find(s => s.id == data.apply_worker_id)
                        let dicsection = this.sectionFidlerHospitalWard.find(s => s.value == data.dic_section_id)
                        let drugsection = this.sectionFidlerHospitalWard.find(s => s.value == data.drug_section_id)
                        console.log(`worker`, worker)
                        console.log(`dicsection`, dicsection)
                        data.apply_worker_id = worker && { label: worker.name, value: worker.id }
                        data.dic_section_id = dicsection
                        data.drug_section_id = drugsection
                        data.items = data.items.map(d => {
                            let r = {
                                id: d.id,
                                biz_drug_apply_id: data.biz_drug_apply_id,
                                dic_drug: { value: d.dic_drug_id, label: d.dic_drug.name, jianpin: d.dic_drug.abbr },
                                dic_drug_id: d.dic_drug_id,
                                apply_count: d.apply_count,
                                reality_count: d.reality_count
                            }
                            return r
                            // { label: d.name, value: d.id }
                        })
                        console.log(data)
                    }
                    resolve(data)
                }).catch(e => reject(e))
            })
        },
        saveOne(row, tp) {
            console.log(`row`, row)
            let that = this
            return new Promise((resolve, reject) => {
                let items = _.reduce(
                    _.groupBy(
                        _.filter(row.items, d => d.dic_drug && d.dic_drug.value),
                        `dic_drug.value`
                    ),
                    function(result, value, key) {
                        let sOne =
                                _.find(value, d => {
                                    return d.id > 0
                                }) || value[0]
                        let r = {
                            id: sOne.id,
                            biz_drug_apply_id: row.id,
                            dic_drug_id: key,
                            apply_count: _.sumBy(value, `apply_count`)
                        }
                        result.push(r)
                        return result
                    },
                    []
                )
                let obj = {
                    id: row.id,
                    apply_date: that.$moment(),
                    apply_worker_id: row.apply_worker_id && row.apply_worker_id.value,
                    apply_type: 1,
                    approve_status: 0,
                    dic_section_id: row.dic_section_id && row.dic_section_id.value,
                    drug_section_id: row.drug_section_id && row.drug_section_id.value,
                    remark: ``,
                    items: items

                }
                console.log(`obj`, obj)
                let req = this.myaxios[tp](`/api/Nursing/DrugApply/${tp}`, obj)
                req.then(data => {
                    resolve(data)
                }).catch(e => reject(e))
            })
        }
    },
    watch: {
        rdate: function() {
            this.refreshList()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Drug/DrugApply.vue